import { combineReducers } from 'redux';
// Reducers
import login from './reducers/loginReducer';
import carrito from './reducers/carritoReducer';

export default combineReducers({
    login,
    carrito
});
